import apiHelper from '../../helper/ApiHelper';

const AdminUserService = {

  async getUsers() {
    try {
      return await apiHelper('/admin/ledgers/users');
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  async getUserById(userId) {
    try {
      return await apiHelper(`/admin/ledgers/users/${userId}`);
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  async deleteUser(userId) {
    try {
      return await apiHelper(`/approval-requests/${userId}`, 'DELETE');
    } catch (error) {
      console.error('Error deleting users:', error);
      throw error;
    }
  },

  async activateUser(userId, updatedStatus) {
    try {
      return await apiHelper(`/approval-requests/update-status/${userId}`, 'POST', { status: updatedStatus });
    } catch (error) {
      console.error('Error activating users:', error);
      throw error;
    }
  },
}

export default AdminUserService;